import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios';
import swal from "sweetalert2";

const DuplicateConfigForm = (props) => {
    const t = useTranslate();
    const [loading,setLoading] = useState(false)
    const [validButton,setValidButton] = useState(false)
    const [error,setError] = useState(false)
    const [authorizeDuplicate,setAuthorizeDuplicate] = useState(false)

    const [configTypeCheck,setConfigTypeCheck] = useState('')
    const [selectCompanyValue,setSelectCompanyValue] = useState('company')

    useEffect(function () {
        if(props.config=='commerce' || props.config=='caisse'){ 
            setConfigTypeCheck('vente_b2c')
        }else{
            setConfigTypeCheck('') 
        }
    }, [props.config])

    useEffect(function () {
        setSelectCompanyValue(props.idCompany)
    }, [props.idCompany])

    useEffect(function () {
        (async function() {
            if(configTypeCheck!=''){
                setError(false)
                setLoading(true)
                setAuthorizeDuplicate(false)

                const response = await axios.get(process.env.REACT_APP_API_URL+"api/compta/compta_correspondance/get_all/"+configTypeCheck
                ).then((response) => {
                    setLoading(false)
                    let idComp = selectCompanyValue=='company' ? null : selectCompanyValue
                    let existingConfig = response.data.datas.find(value => value.other_company_id == idComp)
                    //On vérifie si existingConfig n'est pas undefined et si il existe une configuration sur la page de configuration actuelle 
                    if(!existingConfig || (existingConfig && existingConfig[props.config]==null)){ 
                        setError(t('noConfAvailable'))
                    }else{
                        setAuthorizeDuplicate(existingConfig)
                    }
                    
                }).catch((error) => {
                    if(error=='end_session') return;
                    if(error.response==undefined){
                        swal.fire(t('unknowError'), "", "error");
                    }
                    else if(error.response.status==403){
                        swal.fire(t('forbiddenGeneral'), "", "error");
                    }
                    else {
                        swal.fire(t('unknowError'), "", "error");
                    }
                    setLoading(false)
                })
            }
        })()
    }, [configTypeCheck,selectCompanyValue])

    const handleChange = (value,name) => {
        if(name=='type'){
            setConfigTypeCheck(value)
        }else{
            setSelectCompanyValue(value)
        }
    };

    const submitDuplicate = async () => {
        setValidButton(true)
        let obj = {
            type:props.selectType,
            correspondance:props.config
        }
        if(props.idCompany!='company') obj['other_company'] = props.idCompany

        const response = await axios.post(process.env.REACT_APP_API_URL+"api/compta/compta_correspondance/duplicate_correspondance/"+authorizeDuplicate.id,obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                setError(messageError)

                setValidButton(false)
            }else{
                props.setReload(Date.now())
                setValidButton(false)
                setTimeout(() => {
                    props.setShowDuplicateForm(false)
                }, 1000);
            }
        }).catch((error) => {
            if(error=='end_session') return;
            if(error.response==undefined){
                setError(t('unknowError'));
            }
            else if(error.response.status==403){
                setError(t('forbiddenGeneral'));
            }
            else {
                setError(t('unknowError'));
            }
            setValidButton(false)
        })
    };

    return(<>
        <div className='form-group'>
            <label>{t('selectCompany')}</label>
            <select disabled={loading || validButton} value={selectCompanyValue} className='form-control' onChange={(e)=>handleChange(e.target.value,'company')}>
                <option value="company">{props.company.name}</option>
                {(props.company.other_company) &&
                    props.company.other_company.map((value,ind)=>{
                        return(
                            <option key={value.id }value={value.id}>{value.name}</option>
                        )
                    })
                }
            </select>
        </div>

        <div className='form-group'>
            <label>{t('configurationTypeSelection')}</label>
            <select disabled={loading || validButton || props.config=='commerce' || props.config=='caisse'} value={configTypeCheck} className='form-control' onChange={(e)=>handleChange(e.target.value,'type')}>
                <option value="">-- Select --</option>
                {((selectCompanyValue!=props.idCompany && props.selectType=="vente_b2b") || props.selectType!="vente_b2b") ? 
                    <option value="vente_b2b">{t('b2bSale')}</option> 
                : 
                    false
                }
                {/* (props.config=='commerce' || props.config=='caisse' || ((selectCompanyValue!=props.idCompany && props.selectType=="vente_b2c") || props.selectType!="vente_b2c") */}
                {((selectCompanyValue!=props.idCompany && props.selectType=="vente_b2c") || props.selectType!="vente_b2c") ?        
                    <option value="vente_b2c">{t('b2cSale')}</option> 
                : 
                    false
                }
                {((selectCompanyValue!=props.idCompany && props.selectType=="achat_b2b") || props.selectType!="achat_b2b") ?
                    <option value="achat">{t('purchase')}</option> 
                : 
                    false
                }
            </select>
        </div>

        {loading ? <div className="spinner-border spinner-border-sm" style={{position:'absolute', top:'33%'}}></div> : false}
        {error ? <div className="alert alert-danger mt-1 mb-1">{error}</div> : false}

        <button 
            disabled={!authorizeDuplicate || validButton} 
            className='btn btn-primary mt-3'
            onClick={()=>submitDuplicate()}
        >
            {validButton ? <div className="spinner-border spinner-border-sm"></div> : t('btnValidate') }
        </button>
    </>
    )
}

export default DuplicateConfigForm;